import i18n from "intl/i18n"
import { ErrorCode } from "config/constants"

interface ICustomError<T> {
    message: string
    messageCode: string
    code?: ErrorCode
    payload?: T
}

interface ICustomErrorParams<T> {
    code?: ErrorCode
    payload?: T
    messageCode?: string
    options?: { [x: string]: any }
}

export default class CustomError<T = {}> implements ICustomError<T> {
    code?: ErrorCode
    payload?: T
    messageCode: string
    #options: { [x: string]: any }
    constructor({
        messageCode = "",
        options = {},
        code,
        payload
    }: ICustomErrorParams<T>) {
        this.messageCode = messageCode
        this.#options = options
        this.code = code
        this.payload = payload
    }

    public get message(): string {
        return i18n.t(this.messageCode as any, this.#options) as string
    }
}
